import "./SingleProductTemplate.module.css"
import Header from "@/reusable_sections/Header"
import Product from "./sections/Product"
import Footer from "@/reusable_sections/Footer"

export default function SingleProductTemplatePage() {

  return (
    <div>
      <Header />
      <Product />
      <Footer />
    </div>
  )
}
